<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-06-20 10:24:44
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-20 10:57:28
 * @FilePath: \vjdesign-master\lib\components\test.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mybody2" id="mymapBox">
    <iframe
      src="http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf"
      style="width:500px;height:500px"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'mapTest'
}
</script>

<style>
.mybody2 {
  height: 500px;
  width: 500px;
  background-color: red;
}
</style>